import { HStack, Image, Stack, Text, VStack } from "@chakra-ui/react";
import {
  CraAttributes,
  CraAttributeName,
  CraAttributeSelect,
  TreatmentType,
} from "@keita/lanepatrol-sdk";
import { CraAttributeUtils } from "../../../../coding/utils/attribute-utils";

interface Props {
  treatmentType: TreatmentType;
}
export const StmAttributeChange: React.FC<Props> = ({ treatmentType }) => {
  switch (treatmentType) {
    case TreatmentType.UpgradeExistingFacilityToAnOnRoadBicycleLaneWithLightSegregation:
      return (
        <>
          <OptionChange
            attributeName={CraAttributeName.FacilityType}
            optionIndex={3}
          />
          <Operation text="AND" />
          <OptionChange
            attributeName={CraAttributeName.LightSegregation}
            optionIndex={0}
          />
        </>
      );

    case TreatmentType.UpgradeExistingFacilityToAnOnRoadBicycleLaneWithSafetyBarrierAdjacentRoadLane0To1m:
      return (
        <OptionChange
          attributeName={CraAttributeName.AdjacentFeatures0to1mRoadLane}
          optionIndex={1}
        />
      );
    case TreatmentType.UpgradeExistingFacilityToAnOnRoadBicycleLaneWithSafetyBarrierAdjacentRoadLane1To3m:
      return (
        <OptionChange
          attributeName={CraAttributeName.AdjacentFeatures1to3mRoadLane}
          optionIndex={1}
        />
      );

    case TreatmentType.UpgradeExistingFacilityToACyclingPriorityStreet:
      return (
        <AttributeWithValue
          value="20 Km/h"
          attributeName={CraAttributeName.RoadOperatingSpeed}
        />
      );

    case TreatmentType.UpgradeExistingFacilityToAMultiUsePath:
      return (
        <>
          <OptionChange
            attributeName={CraAttributeName.FacilityType}
            optionIndex={1}
          />
          <Operation text="AND" />
          <OptionChange
            attributeName={CraAttributeName.FacilityWidthPerDirection}
            optionIndex={1}
          />
        </>
      );

    case TreatmentType.UpgradeExistingFacilityToAnOffRoadBicyclePath:
      return (
        <OptionChange
          attributeName={CraAttributeName.FacilityType}
          optionIndex={2}
        />
      );

    case TreatmentType.UpgradeExistingFacilityToAOneWayBicycleFacility:
      return (
        <OptionChange
          attributeName={CraAttributeName.FlowDirection}
          optionIndex={0}
        />
      );

    case TreatmentType.ImproveSurfaceConditions:
      return (
        <OptionChange
          attributeName={CraAttributeName.LooseOrSlipperySurface}
          optionIndex={1}
        />
      );

    case TreatmentType.InstallLightSegregation: {
      return (
        <OptionChange
          attributeName={CraAttributeName.LightSegregation}
          optionIndex={0}
        />
      );
    }

    case TreatmentType.InstallLighting: {
      return (
        <OptionChange
          attributeName={CraAttributeName.StreetLighting}
          optionIndex={0}
        />
      );
    }

    case TreatmentType.ClearFacilityRemovedFixedObstacle: {
      return (
        <OptionChange
          attributeName={CraAttributeName.FixedObstacleOnFacility}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.ClearFacilityRemovedNonFixedObstacles: {
      return (
        <OptionChange
          attributeName={CraAttributeName.NonFixedObstacleOnFacility}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.ClearFacilityRemoveWidthRestriction: {
      return (
        <OptionChange
          attributeName={CraAttributeName.WidthRestriction}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.ImproveFacilityAccess: {
      return (
        <OptionChange
          attributeName={CraAttributeName.FacilityAccess}
          optionIndex={0}
        />
      );
    }

    case TreatmentType.RedesignTheCurve: {
      return (
        <OptionChange
          attributeName={CraAttributeName.Curvature}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.WidenTheFacility: {
      return (
        <OptionChange
          attributeName={CraAttributeName.FacilityWidthPerDirection}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.InstallProtectiveBarrier:
      return (
        <>
          <OptionChange
            attributeName={CraAttributeName.AdjacentFeatures0to1mSevereHazard}
            optionIndex={1}
          />
          <Operation text="AND" />
          <OptionChange
            attributeName={CraAttributeName.AdjacentFeatures1to3mSevereHazard}
            optionIndex={1}
          />
        </>
      );

    case TreatmentType.ImproveDelineation: {
      return (
        <OptionChange
          attributeName={CraAttributeName.Delineation}
          optionIndex={0}
        />
      );
    }

    case TreatmentType.ReviewIntersectionApproach: {
      return (
        <OptionChange
          attributeName={CraAttributeName.IntersectionApproach}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.ImproveSafetyOrCrossingDesign: {
      return (
        <OptionChange
          attributeName={CraAttributeName.CrossingFacility}
          optionIndex={0}
        />
      );
    }

    case TreatmentType.EvaluateNeedForGradeSeparation: {
      return (
        <OptionChange
          attributeName={CraAttributeName.IntersectionOrRoadCrossing}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.ReconfigureOrRemoveParking: {
      return (
        <OptionChange
          attributeName={CraAttributeName.AdjacentFeatures0to1mVehicleParking}
          optionIndex={0}
        />
      );
    }

    case TreatmentType.ReviewConfigurationOfTrainTramRails: {
      return (
        <OptionChange
          attributeName={CraAttributeName.TramOrTrainRails}
          optionIndex={1}
        />
      );
    }

    case TreatmentType.InstallTrafficCalming: {
      return (
        <AttributeWithValue
          value="30 Km/h"
          attributeName={CraAttributeName.RoadOperatingSpeed}
        />
      );
    }

    case TreatmentType.VehiclesSpeedControl: {
      return (
        <HStack justifyContent="center" flexGrow={1}>
          <AttributeWithoutValue
            attributeName={CraAttributeName.RoadOperatingSpeed}
          />
          <Operation text="=" />
          <AttributeWithoutValue
            attributeName={CraAttributeName.RoadSpeedLimit}
          />
        </HStack>
      );
    }

    case TreatmentType.BicyclesSpeedControl: {
      return (
        <OptionChange
          attributeName={CraAttributeName.BicycleAndLVSpeedAverage}
          optionIndex={0}
        />
      );
    }

    default: {
      console.warn("StmAttributeChange: treatment not implemented.");
      return null;
    }
  }
};

const AttributeWithoutValue: React.FC<{
  attributeName: CraAttributeName;
}> = ({ attributeName }) => {
  const attributeDefinition = CraAttributes.getByName(
    attributeName,
  ) as CraAttributeSelect;
  const label = CraAttributeUtils.getLabel(attributeName);
  return (
    <VStack maxW="140px">
      <Image
        w="60px"
        title={label}
        alt={label}
        src={CraAttributeUtils.getImage(attributeDefinition, null)}
      />
      <Text
        fontSize="xs"
        fontWeight="bold"
        textTransform="uppercase"
        textAlign="center"
      >
        {label}
      </Text>
    </VStack>
  );
};

const AttributeWithValue: React.FC<{
  value: string;
  attributeName: CraAttributeName;
}> = ({ value, attributeName }) => {
  const attributeDefinition = CraAttributes.getByName(
    attributeName,
  ) as CraAttributeSelect;
  return (
    <HorizontalDisplay
      label={CraAttributeUtils.getLabel(attributeName)}
      value={value}
      imageSrc={CraAttributeUtils.getImage(attributeDefinition, null)}
    />
  );
};

const Operation: React.FC<{
  text: string;
}> = ({ text }) => {
  return (
    <Text fontSize="xs" fontWeight="bold">
      {text}
    </Text>
  );
};

const OptionChange: React.FC<{
  attributeName: CraAttributeName;
  optionIndex: number;
}> = ({ attributeName, optionIndex }) => {
  const attributeDefinition = CraAttributes.getByName(attributeName)!;
  const option = (attributeDefinition as CraAttributeSelect).options[
    optionIndex
  ];

  return (
    <HorizontalDisplay
      label={CraAttributeUtils.getLabel(attributeName)}
      value={CraAttributeUtils.getOptionLabel(option.value)}
      imageSrc={CraAttributeUtils.getImage(attributeDefinition, option.value)}
    />
  );
};

const HorizontalDisplay: React.FC<{
  value: string;
  label: string;
  imageSrc?: string;
}> = ({ value, imageSrc, label }) => {
  return (
    <HStack gap={0} flex={1} justifyContent="center">
      <Image w="60px" title={label} alt={label} src={imageSrc} />
      <Stack gap={0}>
        <Text
          fontSize="xs"
          fontWeight="bold"
          textTransform="uppercase"
          textAlign="center"
        >
          {label}
        </Text>
        <Text fontSize="sm">{value}</Text>
      </Stack>
    </HStack>
  );
};
